function navSearch() {
    var search = document.getElementById('search');
    if (window.localStorage) {
        if (!search.value) search.value = window.localStorage.getItem('lastSearchKeywords');
       // if (placePicker && !placePicker.value) placePicker.value = window.localStorage.getItem('lastSearchLocation');

        window.localStorage.setItem('lastSearchKeywords', search.value);
      //  window.localStorage.setItem('lastSearchLocation', (placePicker ? placePicker.value : ''))
    }
}
function searchForm() {
    return wireupSearchForm('/search');
}
function ownerPageSearchForm() {
    return wireupSearchForm('/ownersearch');
}
function wireupSearchForm(searchUrl) {
    var search = document.getElementById('search');
    var searchAutocomplete = document.getElementById('searchAutocomplete');
    var placePicker = document.getElementById('searchPlacePicker');
    var location = document.getElementById('searchLocation');
    var radius = document.getElementById('radius');
    var searchRadius = document.getElementById('searchRadius');
    var cmdGeoLocate = document.getElementById('cmdGeoLocate');

    if (cmdGeoLocate && navigator && navigator.geolocation) {
        cmdGeoLocate.addEventListener('click', function () {
            navigator.geolocation.getCurrentPosition(function (p) {
                var latlng = new google.maps.LatLng(p.coords.latitude, p.coords.longitude);
                new google.maps.Geocoder().geocode({ 'latLng': latlng }, function (results, status) {
                    if (status == google.maps.GeocoderStatus.OK) {
                       // console.log(results)
                        results.forEach(function (e) {
                            if (e.types.indexOf('postal_code') > -1) {
                                location.value = e.formatted_address;
                                var radiusKm = radius ? radius.value : 160;
                                var newUrl = searchUrl + '/' + encodeURIComponent(e.formatted_address) + '/' + encodeURIComponent(search.value) + "?lat=" + e.geometry.location.lat() + "&lon=" + e.geometry.location.lng() + "&radius=" + radiusKm;;
                                window.location.href = newUrl;
                            }
                        });

                    } else {
                        console.log("Geocoder failed due to: " + status);
                    }
                });
            });
        });
    }
    if (window.localStorage) {
        //if (!search.value) search.value = window.localStorage.getItem('lastSearchKeywords');
        //if (placePicker && !placePicker.value) placePicker.value = window.localStorage.getItem('lastSearchLocation');

        window.localStorage.setItem('lastSearchKeywords', search.value);
        window.localStorage.setItem('lastSearchLocation', placePicker ? placePicker.value : '');
    }
   // search.focus(); this causes scroll to top when you use back button.  Figure out a way to only focus on 1st view.
    if (radius && searchRadius) {
        radius.addEventListener('change', function () {
            searchRadius.value = radius.value;
            
        });
    }
    if (placePicker) {
        var placePickerOptions = { types: ['(regions)'] };
        var placePickerAutocomplete = new google.maps.places.Autocomplete(placePicker, placePickerOptions);
        placePicker.addEventListener('blur', function () {
            if (placePicker.value === '' && location.value !== '')
                window.location.href = searchUrl+'/world/' + encodeURIComponent(search.value);
        });
        placePickerAutocomplete.addListener('place_changed', function () {
            var place = placePickerAutocomplete.getPlace();
            var radiusKm = radius ? radius.value : 160;
           // console.log(place);
            if (!place || !place.formatted_address) return;
            newUrl = searchUrl + '/' + encodeURIComponent(place.formatted_address) + '/' + encodeURIComponent(search.value);
            if (radius&&searchRadius&&place && place.geometry && place.geometry.location) newUrl = newUrl + "?lat=" + place.geometry.location.lat() + "&lon=" + place.geometry.location.lng() + "&radius=" + radiusKm;

            window.location.href = newUrl;
        });
    }


    searchAutocomplete.addEventListener('click', function (e, t) {
        var evt = e ? e : window.event;
        if (evt.stopPropagation) evt.stopPropagation();
        if (evt.cancelBubble !== null) evt.cancelBubble = true;
        //Prevent click on autocomplete from triggering body click.
    });

    document.body.addEventListener('click', function () {
        searchAutocomplete.classList.remove('has-matches');
    });

    //TODO: Take N
    if (search && search.dataset && 'customautocomplete' in search.dataset) {
        var autoCompleteUrl = searchUrl +'/autocomplete?take=4&location=' + (placePicker ? placePicker.value : '') + '&search=';
        customAutoCompleteWithPartial(search, autoCompleteUrl, function (res) {
            if (res) {
                var markup = res.data.results || res.data;
                searchAutocomplete.innerHTML = markup;
                searchAutocomplete.classList.add('has-matches');
                if (window.localStorage) {
                    window.localStorage.setItem('lastSearchKeywords', search.value);
                    window.localStorage.setItem('lastSearchLocation', placePicker ? placePicker.value : '');
                }
                if (LazyLoad) {
                    var myLazyLoad = new LazyLoad({
                        container: searchAutocomplete
                    });
                }
            } else {

                searchAutocomplete.classList.remove('has-matches');
            }
        });

    }
}
